import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class CardBlockComponent extends Component {
  render() {
    return (
      <div className="card-wrapper">
        <div className="card">
          <div className="card-header">
            {
              this.props.valid ?
                <h1 className="title">Erro ao validar conta!</h1>
              : <h1 className="title">A conta informada não foi encontrada.</h1>
            }
          </div>
          <div className="card-body">
            {
              this.props.valid ?
                <div className="content-group">
                  <p>O usuário informado já foi validado ou o dado encontra-se corrompido.</p>
                  <Link to="/signin" className="btn btn-blue">Realizar login</Link>
                </div>
              : <div className="content-group">
                  <p>Não foi encontrado nenhum usuário na base como informado. Verifique sua caixa de e-mails para acessar o link correto enviado.</p>
                  <Link to='/signup/company' className="btn btn-blue">Realizar cadastro</Link>
                </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default CardBlockComponent;